<!-- <ngx-spinner type=''>
  <div class="loader">
    <img src='/assets/images/logo/supernowa-loader-black.gif' />
  </div>
  <div id="loader">
    <div class="loader">
        <div class="loader-circle"></div>
        <div class="loader-line-mask">
            <div class="loader-line"></div>
        </div>
        <img src="assets/images/supernowa-logo-mobile.png" alt="">
    </div>
  </div>
</ngx-spinner> -->
<app-header></app-header>
<app-market-history></app-market-history>
<app-round-history></app-round-history>
<router-outlet></router-outlet>
<!-- <app-footer></app-footer> -->
